module.exports = ".periodo {\n  margin-top: 10px;\n  float: right; }\n\n.table th:not(:first-child) {\n  width: 190px; }\n\n@media print {\n  .table th,\n  .table td {\n    font-size: 10px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/extratos/relatorio/relatorio.component.scss
// module id = ./src/app/extratos/relatorio/relatorio.component.scss
// module chunks = main